import { render, staticRenderFns } from "./global-warning.vue?vue&type=template&id=f081ebaa"
import script from "./global-warning.vue?vue&type=script&lang=js"
export * from "./global-warning.vue?vue&type=script&lang=js"
import style0 from "./global-warning.vue?vue&type=style&index=0&id=f081ebaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports